module.exports = __webpack_public_path__ + "files/668d0a0e7a0189f62898bcc57ab8370c.png";


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-colorpicker/dist/img/bootstrap-colorpicker/saturation.png
// module id = 591
// module chunks = 60